import React from "react";

/**
 * EmptyState — reusable "no records" placeholder for module tables.
 * Rendered inside a full-width table row.
 */
const EmptyState = ({ colSpan = 100, message = "No records found", icon = "bx-folder-open" }) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <div className="no-found text-center py-5 text-muted">
        <i className={`bx ${icon}`} style={{ fontSize: 42, opacity: 0.5 }}></i>
        <p className="mb-0 mt-2">{message}</p>
      </div>
    </td>
  </tr>
);

export default EmptyState;
